export default __webpack_public_path__ + "static/media/regulatory--passing-lane-ahead--g1.f3e273fd.png";